module.exports = {"title":"Switch User","all":"All Clients","logout":"Logout as client"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SwitchUser/locales/fr.json
// module id = 890
// module chunks = 0